import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettingSecurity: React.FC<IconProps> = ({ width = 20, height = 20, color }) => {
    const strokeColor = color || '#7F7F7F';

    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_83604)">
                <path
                    d="M16.875 8.75V4.375C16.875 4.20924 16.8092 4.05027 16.6919 3.93306C16.5747 3.81585 16.4158 3.75 16.25 3.75H3.75C3.58424 3.75 3.42527 3.81585 3.30806 3.93306C3.19085 4.05027 3.125 4.20924 3.125 4.375V8.75C3.125 16.25 10 18.125 10 18.125C10 18.125 16.875 16.25 16.875 8.75Z"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_83604">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettingSecurity;
